// @flow
import * as React from 'react';
import classNames from 'classnames';
import Button, { type ButtonProps } from 'components/atoms/button/Button';
import Headline, {
  type HeadlineProps,
} from 'components/atoms/headline/react/Headline';
import randomString from 'javascripts/utils/random-id';

type Item = {
  ...ButtonProps,
  isCloseButton: boolean,
  text: string,
};

type Props = {
  headline?: HeadlineProps,
  text?: string,
  buttons?: {
    alignment?: 'right' | 'center',
    items: Array<Item>,
  },
  id?: string,
  className?: string,
  onCloseDialog?: Function,
  trigger: HTMLElement,
};

const DialogContent = (props: Props): React.MixedElement => {
  const {
    headline,
    buttons = { items: [], alignment: 'right' },
    id,
    className,
    text,
    onCloseDialog,
    trigger,
  } = props;

  const labelId =
    (id && `${id}-label`) || `dialog-content-${randomString()}-label`;

  const DialogContentClasses = classNames(
    {
      'dialog-content': true,
    },
    className
  );

  return (
    <div className={DialogContentClasses}>
      {headline && headline.text && (
        <div className="dialog-content__headline">
          <Headline {...headline} id={labelId}>
            {headline.text}
          </Headline>
        </div>
      )}
      {text && (
        <div
          className="dialog-content__text text"
          dangerouslySetInnerHTML={{ __html: text }}
        ></div>
      )}

      {buttons && buttons.items && (
        <div
          className={classNames({
            'dialog-content__buttons': true,
            [`dialog-content__buttons--${buttons.alignment || ''}`]:
              buttons.alignment,
          })}
        >
          {buttons.items.map((item, index) => {
            const { text: buttonText, isCloseButton, ...rest } = item;

            if (!buttonText) {
              return null;
            }

            return (
              <Button
                className="dialog-content__button"
                key={index}
                onClick={isCloseButton ? onCloseDialog : item.onClick}
                {...rest}
                link={!isCloseButton ? (trigger.getAttribute('href'): any) : ''}
              >
                {buttonText}
              </Button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DialogContent;
